import { Repeat } from "lucide-react";

export const RecurrenceBadge = ({ label, className = "", testid = "recurrence-badge" }) => {
  if (!label) return null;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 text-xs font-semibold text-wyd-accent ${className}`}>
      <Repeat size={12} /> {label}
    </span>
  );
};
